import { render, staticRenderFns } from "./PricePartsDetails.vue?vue&type=template&id=6a7616b3"
import script from "./PricePartsDetails.vue?vue&type=script&lang=js"
export * from "./PricePartsDetails.vue?vue&type=script&lang=js"
import style0 from "./PricePartsDetails.vue?vue&type=style&index=0&id=6a7616b3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports